/* IB-7 v15 (Theme-Port 14.10.2026). Quelle design/prototyp/v15/v15-site.js. */
/* IB-7 v15-site.js (Entwurf 14.10.2026, Claude). Auf allen v15-Seiten, Vanilla JS, defer.
   Prompter für Statement-Sätze (.v10-statement__text): Wörter füllen sich beim Scrollen. Ohne JS oder bei
   reduzierter Bewegung steht der Satz fertig da. Shopify: Web Component ib7-manifest. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  var wrapText = function (node, accent) {
    if (node.nodeType === 3) {
      var frag = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(function (t) {
        if (!t) return;
        if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); return; }
        var s = document.createElement('span'); s.className = 'w' + (accent ? ' is-accent' : ''); s.textContent = t; frag.appendChild(s);
      });
      node.parentNode.replaceChild(frag, node);
    } else if (node.nodeType === 1 && !node.classList.contains('v10-cap')) {
      Array.prototype.slice.call(node.childNodes).forEach(function (c) { wrapText(c, accent || node.tagName === 'EM'); });
    }
  };
  var init = function (p) {
    if (p.hasAttribute('data-v15-words')) return; /* Startseite hat eigene Logik */
    Array.prototype.slice.call(p.childNodes).forEach(function (c) { wrapText(c, false); });
    var list = p.querySelectorAll('.w');
    if (reduce) { list.forEach(function (w) { w.classList.add('is-on'); }); return; }
    var raf = 0;
    var update = function () {
      raf = 0;
      var r = p.getBoundingClientRect(), vh = window.innerHeight;
      var n = Math.round(clamp((vh * 0.82 - r.top) / (r.height + vh * 0.3)) * list.length);
      list.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
    };
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  };
  var start = function () { document.querySelectorAll('.v10-statement__text').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
